export default __webpack_public_path__ + "static/media/shape4.f8e181d2.svg";